import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
export default function useFragmentLink(fragment) {
    var hash = useLocation().hash;
    var navigate = useNavigate();
    return React.useCallback(function() {
        if (hash === "#".concat(fragment)) {
            navigate({});
        }
        setTimeout(function() {
            return navigate("#".concat(fragment));
        }, 1);
    }, [
        fragment,
        hash,
        navigate
    ]);
}
